import React, { useMemo } from 'react';
import SelectCompanyNavItem from '@fingo/lib/components/company/SelectCompanyNavItem';
import { LoggedInNavItems, ProfileNavItem } from '@fingo/lib/components/layout/navbar';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { NavbarLink } from '@fingo/lib/components/links';
import { logOut } from '@fingo/lib/apollo/helpers/auth';
import { useApolloClient } from '@apollo/client';
import { useGetUser } from '@fingo/lib/hooks';
import LogoutIcon from '@mui/icons-material/Logout';
import useWorkspaceRoutes from '../../../hooks/useWorkspaceRoutes';

const LoggedInDesktopNavItems = () => {
  const client = useApolloClient();
  const theme = useTheme();
  const { navbarHeight } = theme.components.MuiToolbar;
  const user = useGetUser();
  const workspaceRoutes = useWorkspaceRoutes();
  const routes = useMemo(
    () => workspaceRoutes.filter(({ showInNavbar }) => !!showInNavbar),
    [],
  );

  return (
    <Stack
      width="100%"
      direction="row"
      spacing={3.5}
      height={navbarHeight}
      alignItems="center"
      justifyContent="flex-end"
    >
      <LoggedInNavItems routes={routes} />
      <ProfileNavItem
        credentialsMissing={0}
        profileMissing={0}
        text="Mi cuenta"
        gap="11px"
      />
      {user?.isStaff && <SelectCompanyNavItem ml={0} />}
      <NavbarLink
        id="logout"
        title="Cerrar sesión"
        to="/login"
        onClick={() => { logOut(client); }}
        icon={<LogoutIcon sx={{ fontSize: 24 }} />}
      />
    </Stack>
  );
};

export default LoggedInDesktopNavItems;
